import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class UserService {

    constructor(private http: HttpClient) { }

	getUsers(): Observable<Array<IUserModel>> {
		return this.http.get(`${Constants.restUrl}User/GetUsers`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}